import React from 'react';
import { Colors } from '@common/tokens';

const GRID_COLS = 7;
const GRID_ROWS = 5;

/** Cells cycle through these colors as they fill in alongside step progress. */
const CELL_COLORS = [
  Colors.elm,
  Colors.skyRegular,
  Colors.sunDarker,
  Colors.steelDarker,
];

/** Abstract schedule grid whose cells fill with color as steps complete. */
export function LoadingGrid({
  currentStep,
  totalSteps,
}: {
  currentStep: number;
  totalSteps: number;
}) {
  const cells = buildGridCells(currentStep, totalSteps);

  return (
    <div className="wk-full-screen-loading-grid__grid">
      {cells.map((color, i) => (
        <div
          key={i}
          className="wk-full-screen-loading-grid__cell"
          style={{ background: color }}
        />
      ))}

      <style jsx>{`
        .wk-full-screen-loading-grid__grid {
          display: grid;
          grid-template-columns: repeat(${GRID_COLS}, 1fr);
          grid-template-rows: repeat(${GRID_ROWS}, 20px);
          gap: 4px;
        }
        .wk-full-screen-loading-grid__cell {
          border-radius: 4px;
          transition: background 0.6s ease;
        }
      `}</style>
    </div>
  );
}

function buildGridCells(currentStep: number, totalSteps: number): string[] {
  const total = GRID_COLS * GRID_ROWS;
  const filled =
    totalSteps > 0 ? Math.round((currentStep / totalSteps) * total) : 0;
  return Array.from({ length: total }, (_, i) =>
    i < filled ? CELL_COLORS[i % CELL_COLORS.length] : Colors.steelLighter
  );
}
